<template>
  <div class="widget_holder">
    <div class="widget_header">
      <div class="widget_header_content">
        <div class="widget_header_title">
          <span :class="widget.iconClass" />
          <span class="heading_title">{{ tableTile }}</span>
        </div>
        <div class="widget_header_right_content">
          <slot name="headerContent" />
        </div>
      </div>
    </div>
    <div class="widget_content">
      <slot />
      <div class="clearfix" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PortalWidget',
  props: {
    widget: {
      type: Object,
      default: () => {
        return { title: 'Ringba', iconClass: 'fa fa-dot-circle-o' };
      }
    }
  },
  computed: {
    tableTile() {
      return this.widget.tableTitle ?? this.widget.title;
    }
  },
  mounted() {
    if(this.widget.title) {
      document.title = this.widget.title;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
